/// <reference path="../../types.d.ts" />
import { commonActions } from '@codametrix/ui-common';
import { connect } from 'react-redux';
import {
  fetchCaseRunDocuments,
  fetchDocument,
  loadDocuments
} from '../../actions/case-documents.actions';
import { setActiveProcess } from '../../actions/json-view';
import CaseDocumentsApp from './case-documents';
//@ts-ignore
import { authenticationChannel } from '@codametrix/ui-common';
import { dismissFeedback } from '../../actions/ui';

const mapStateToProps = function(state: any) {
  return {
    ...state.documents
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onSelect: (docMetadata: CMxAPI.DocumentMetadata) => {
      dispatch(fetchDocument(docMetadata));
    },
    registerActivity: () => {
      authenticationChannel.postMessage({
        type: commonActions.AuthenticatedWindow.ACTIVITY,
        payload: true,
        meta: {
          suppressRedux: true
        }
      });
    },
    dismissFeedback: (message: commonActions.CMxApplication.FEEDBACK) =>
      dispatch(dismissFeedback(true)),
    getORUs: (args: any) => {
      dispatch(loadDocuments(args));
    },
    setActiveProcess: async (caseRun: CMxAPI.CaseRun) => {
      dispatch(setActiveProcess(caseRun));
      await dispatch(fetchCaseRunDocuments(caseRun));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseDocumentsApp);
